// FULSAS-14570: the "then $X/mo" amount on a proposal option must be the sum of
// the option's MONTHLY RECURRING charges only. One-time fees (e.g. the website
// design fee) and annual plans are charged up front ("Due Today"), so counting
// their price here made "then" overstate what the client pays each month.

const isMonthlyBilled = entry => entry?.billingFrequency !== 'annual'

// A top-level item recurs monthly unless it is a one-time fee or billed
// annually. Items with no billingFrequency are treated as monthly, like the
// Order Summary does (`billingFrequency !== 'annual'`).
export const isMonthlyRecurringItem = item =>
  item?.productType !== 'ONE_TIME_FEE' && isMonthlyBilled(item)

// A nested add-on recurs monthly unless it is annual itself. An add-on with no
// explicit frequency under an annual parent follows the parent (annual).
const isMonthlyRecurringAddon = (addon, parent) =>
  addon?.productType !== 'ONE_TIME_FEE' &&
  (addon?.billingFrequency === 'monthly' ||
    (isMonthlyBilled(addon) && isMonthlyBilled(parent)))

// items: a proposal option's items.
// isDisplaced(productCode): items replaced by a newer MC plan are skipped.
// skipIncludedAddons: ignore add-ons already on the account (the Send modal
//   does; the preview keeps counting them).
export function getMonthlyRecurringTotal(
  items = [],
  {isDisplaced = () => false, skipIncludedAddons = false} = {},
) {
  return items.reduce((sum, item) => {
    if (isDisplaced(item.productCode)) return sum
    // A one-time fee has no recurring part at all, add-ons included.
    if (item.productType === 'ONE_TIME_FEE') return sum
    const addonsTotal = (item.addons || []).reduce((aSum, addon) => {
      if (skipIncludedAddons && addon.alreadyIncluded) return aSum
      if (!isMonthlyRecurringAddon(addon, item)) return aSum
      return aSum + Number(addon.recurringAmount ?? addon.unitPrice ?? 0)
    }, 0)
    // An annual plan's own price is charged up front, but a monthly add-on
    // nested under it still recurs monthly (counted above).
    const ownTotal = isMonthlyRecurringItem(item)
      ? Number(item.recurringAmount ?? item.price ?? item.unitPrice ?? 0)
      : 0
    return sum + ownTotal + addonsTotal
  }, 0)
}
